import { ORDER_BY_CREATED } from "mds/hooks/use-ordered";
import {
  breakoutGroupSelectors,
  classUserSelectors,
  createAppSelector,
  pageGroupSelectors,
} from "store/selectors/base";
import { selectActiveClassSession } from "store/selectors/class-session";
import { selectCurrentClassUser } from "store/selectors/class-user";

export const selectIsInBreakout = createAppSelector(
  [selectActiveClassSession],
  (classSession) => !!classSession?.breakout_session_ends_at,
);

export const selectOrderedBreakoutGroups = createAppSelector(
  [
    selectActiveClassSession,
    breakoutGroupSelectors.filterForCurrentSection,
    pageGroupSelectors.selectAll,
  ],
  (classSession, breakout_groups, page_groups) => {
    let breakoutGroups = breakout_groups;

    if (
      !!classSession?.breakout_session_ends_at &&
      !!classSession?.breakout_session_synced_page_id
    ) {
      const syncedPageGroupById = page_groups
        .filter((pageGroup) => pageGroup.page_id === classSession.breakout_session_synced_page_id)
        .toSorted(ORDER_BY_CREATED)
        .reduce((acc, item) => ({ ...acc, [item.id]: item }), {});

      breakoutGroups = breakout_groups.map((breakoutGroup) => ({
        ...breakoutGroup,
        created_at_ms:
          syncedPageGroupById[breakoutGroup.page_group_id ?? ""]?.created_at_ms ??
          breakoutGroup.created_at_ms,
      }));
    }

    return breakoutGroups
      .toSorted(ORDER_BY_CREATED)
      .map((bg, index) => ({ ...bg, number: index + 1 }));
  },
);

export const selectFullBreakoutGroups = createAppSelector(
  [selectOrderedBreakoutGroups, classUserSelectors.filterForCurrentSection],
  (breakout_groups, classUsers) => {
    return breakout_groups.map((breakout_group) => {
      return {
        ...breakout_group,
        members: classUsers.filter((cu) => cu.breakout_group_id === breakout_group.id),
      };
    });
  },
);

export const selectCurrentBreakoutGroup = createAppSelector(
  [selectFullBreakoutGroups, selectCurrentClassUser],
  (breakoutGroups, classUser) =>
    breakoutGroups.find((bg) => bg.id === classUser?.breakout_group_id) || null,
);

export const selectCurrentListenedBreakoutGroup = createAppSelector(
  [selectFullBreakoutGroups, selectCurrentClassUser],
  (breakoutGroups, classUser) =>
    breakoutGroups.find((bg) => bg.id === classUser?.listened_breakout_group_id) || null,
);

export const selectCurrentBreakoutGroupId = createAppSelector(
  [selectCurrentClassUser],
  (classUser) => classUser?.breakout_group_id || null,
);

export const selectCurrentListenedBreakoutGroupId = createAppSelector(
  [selectCurrentClassUser],
  (classUser) => classUser?.listened_breakout_group_id || null,
);
